import React, {Component} from 'react';
import './transaction.scss'
export default class transaction extends Component {
  render() {    
    return (
      <div className="page-transaction">
        Hello transaction
      </div>
    )
  }
}